<app-adminav></app-adminav>
<div class="container">
    <div class="col-lg-12 mt-5">
        <h4>Listado de post en el blog:</h4>
        <hr>
        <table class="table mt-3 animated fadeIn faster">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Título</th>
                    <th scope="col">Creado</th>
                    <th scope="col">Introducción</th>
                    <th scope="col">Detalle</th>
                    <th scope="col">Editar</th>
                    <th scope="col">Eliminar</th>
                </tr>
            </thead>
            <tbody class="text-left">
                <tr *ngFor="let post of posts">
                    <td *ngIf="post.video =='No'"><img [src]="post.imagen" class="img-fluid" alt="Responsive image" width="150"></td>
                    <td *ngIf="post.video =='Si'"><img src="../../../../assets/img/film.png" class="img-fluid" alt="Responsive image" width="150"></td>
                    <td>{{post.titulo}}</td>
                    <td>{{post.creado}}</td>
                    <td>{{post.introduccion}}</td>
                    <td>
                        <button class="btn btn-success" title="Detalle" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(post)">
                            <i class="fa fa-list fa-lg"></i>
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-primary" title="Editar" (click)="editarpost(post)">
                            <i class="fa fa-edit fa-lg"></i>
                        </button>
                    </td>
                    <td>
                      <button class="btn btn-danger" title="Eliminar" (click)="borrarPost(post.id)">
                          <i class="fa fa-trash fa-lg"></i>
                      </button>
                  </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div *ngIf="post" class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Detalle del artículo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <div class="card mb-3">
                  <div *ngIf="post.video == 'Si'" class="text-center">
                    <iframe width="560" height="315" [src]="getVideoIframe(post.imagen)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                    <img *ngIf="post.video == 'No'" [src]="post.imagen" class="card-img-top" alt="...">
                    <div class="card-body">
                        <h5 class="card-title">{{post.titulo}}</h5>
                        <p *ngFor="let item of post.contenido" class="card-text">{{item}}</p>
                        <div class="col-lg-12">
                            <h5>Comentarios</h5>
                            <hr>
                            <table class="table table-responsive mt-3">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">Comentario</th>
                                        <th scope="col">usuario</th>
                                        <th scope="col">fecha</th>
                                        <th scope="col">Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody class="text-left">
                                    <tr *ngFor="let item of comentarios">
                                        <td>{{item.comentario}}</td>
                                        <td>{{item.autor}}</td>
                                        <td>{{item.fecha | date}}</td>
                                        <td>
                                            <button class="btn btn-danger" title="Eliminar" (click)="deleteComment(item.id)">
                                                <i class="fa fa-trash fa-lg"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
